import { z } from "zod";

export const VipLevelDefSchema = z.object({
  level: z.number().int().min(1).max(20),
  /** Cumulative VIP points required. */
  points: z.number().int().min(1),
  productionPct: z.number().min(0),
  buildSpeedPct: z.number().min(0),
  unlocks: z.array(z.string()),
});
export type VipLevelDef = z.infer<typeof VipLevelDefSchema>;
